import { useEffect, useState } from "react";
import "../../../newComponents/listings/top-listing-headers/top-listing-headers.css";
import SearchFilterInput from "../../../newComponents/form-fields/search-filter-input";
import SimpleButton from "../../../newComponents/buttons/Simple-button";
import H2 from "../../../newComponents/typography/H2";
import SortIcon from "../../../assets/svgs/SortIcon";

interface ManageUsersTopHeaderProps {
  className?: string;
  PageHeading?: string;
  Count?: number;
  ButtonName?: string;
  MobileButtonName?: string;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  onClick?: () => void;
  handleFilterChange?: (filter: string) => void;
  aggregateValuesFilters?: Record<string, number>;
  sortDirection: "asc" | "desc";
  onSortChange: (direction: "asc" | "desc") => void;
}

export default function ManageUsersTopHeader({
  className = "",
  PageHeading,
  Count,
  ButtonName,
  MobileButtonName,
  searchTerm,
  setSearchTerm,
  onClick,
  handleFilterChange,
  aggregateValuesFilters,
  sortDirection,
  onSortChange,
}: ManageUsersTopHeaderProps) {
  const [filterOptions, setFilterOptions] = useState<{ title: string; count: number }[]>([]);
  const [activeFilter, setActiveFilter] = useState("All");
  const [shouldUpdateCounts, setShouldUpdateCounts] = useState(true);

  useEffect(() => {
    if (aggregateValuesFilters && Count !== undefined && shouldUpdateCounts) {
      const options = Object.entries(aggregateValuesFilters).map(([title, count]) => ({
        title,
        count,
      }));
      const totalCount = options.reduce((acc, curr) => acc + curr.count, 0);
      setFilterOptions([{ title: "All", count: totalCount }, ...options]);
    }
  }, [aggregateValuesFilters, Count, shouldUpdateCounts]);

  useEffect(() => {
    setShouldUpdateCounts(true);
  }, [searchTerm]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handleFilterTabChange = (title: string) => {
    setActiveFilter(title);
    setShouldUpdateCounts(false);
    handleFilterChange(title);
  };

  return (
    <div className={`top-listing-header manage-users-header ${className}`}>
      <div className="top-listing-header-main">
        <div className="top-listing-header-left">
          <H2 text={`${PageHeading || ""}${Count !== undefined ? ` (${Count})` : ""}`} />
        </div>

        <div className="top-listing-header-right">
          <div className="manage-users-header-actions">
            <SearchFilterInput
              placeholder="Search by User Name"
              searchTerm={searchTerm}
              handleSearch={handleSearch}
            />
            <div className="search-sort-container">
              <div className="sort-button"
                onClick={() => onSortChange(sortDirection === "asc" ? "desc" : "asc")}>
                <span className="sort-text">
                  {sortDirection === "asc"
                    ? "Sort by: A-Z"
                    : "Sort by: Z-A"}
                </span>
                <SortIcon />
              </div>
            </div>

            {ButtonName && (
              <SimpleButton
                className="top-listing-header-button-desktop"
                label={ButtonName}
                onClick={onClick}
              />
            )}
            {(MobileButtonName || ButtonName) && (
              <SimpleButton
                className="top-listing-header-button-mobile"
                label={MobileButtonName || ButtonName}
                onClick={onClick}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}